import { Controller } from "@hotwired/stimulus"

// Assembles a `mailto:` link at runtime from a split user + domain so the full
// address never appears contiguously in the static HTML — naive harvesters that
// scrape for `user@domain` come up empty. Set `reveal` to also print the
// assembled address as the link's text (for links that should *show* the email).
export default class extends Controller {
  static values = { user: String, domain: String, reveal: Boolean }

  connect() {
    if (!this.userValue || !this.domainValue) return
    const address = `${this.userValue}@${this.domainValue}`
    this.element.setAttribute("href", `mailto:${address}`)
    if (this.revealValue) this.element.textContent = address
  }
}
